import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";



const customTheme = extendTheme({ 
    styles: {
        global: {          
            "body": {
                backgroundColor: "cyan.400",
            }           
        },
    }   
});

export default customTheme;
